export enum View {
  Map = 'map',
  Listing = 'listing',
}
